import { apiSlice } from '../api/apiSlice'
import { VacationAcknowledgement } from '../../types/utils/VacationTypes'

export interface VacationAcknowledgementDTO {
  vacationId: string
  vacationAddedDate: string
  acknowledgements: VacationAcknowledgement[]
}

export type VacationAcknowledgementMap = Record<string, VacationAcknowledgementDTO>

export const vacationAcknowledgementApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getVacationAcknowledgement: builder.query<VacationAcknowledgementDTO, string>({
      query: vacationId => `vacation/acknowledgement/${vacationId}`,
      transformErrorResponse: response => response.data,
      providesTags: (_result, _error, vacationId) => [{ type: 'VacationAcknowledgement', vacationId }],
    }),
    getVacationAcknowledgementsBulk: builder.query<VacationAcknowledgementMap, string[]>({
      query: ids => ({
        url: `vacation/acknowledgement/bulk`,
        method: 'POST',
        body: { vacationIds: ids },
      }),
      transformErrorResponse: response => response.data,
      providesTags: (_result, _error, vacationIds) => [
        { type: 'VacationAcknowledgement' },
        ...vacationIds.map(id => ({ type: 'VacationAcknowledgement' as const, id })),
      ],
    }),
    acknowledgeVacation: builder.mutation<void, string>({
      query: vacationId => ({
        url: `vacation/acknowledgement/${vacationId}/acknowledge`,
        method: 'POST',
      }),
      transformErrorResponse: response => response.data,
      invalidatesTags: (_result, _error, vacationId) => [
        { type: 'VacationAcknowledgement', vacationId },
        { type: 'Vacation' },
        { type: 'Vacation', id: 'UPCOMING_LIST' },
      ],
    }),
    cancelVacationAcknowledgement: builder.mutation<void, string>({
      query: vacationId => ({
        url: `vacation/acknowledgement/${vacationId}/acknowledge`,
        method: 'DELETE',
      }),
      transformErrorResponse: response => response.data,
      invalidatesTags: (_result, _error, vacationId) => [
        { type: 'VacationAcknowledgement', vacationId },
        { type: 'Vacation' },
        { type: 'Vacation', id: 'UPCOMING_LIST' },
      ],
    }),
  }),
})

export const {
  useGetVacationAcknowledgementQuery,
  useGetVacationAcknowledgementsBulkQuery,
  useAcknowledgeVacationMutation,
  useCancelVacationAcknowledgementMutation,
} = vacationAcknowledgementApiSlice
